/**
 * Frozen pose for capturing a flower-pack still with spin-scene lighting.
 * Rotations are in degrees (easier in Tweakpane); applied on the packet group
 * after the model’s base normalize rotation (Y = -90°).
 */
export type PacketPoseSettings = {
  /** When true, idle float/heartbeat/taps are frozen and pose sliders drive the model. */
  enabled: boolean;
  positionY: number;
  rotationXDeg: number;
  rotationYDeg: number;
  rotationZDeg: number;
  scale: number;
};

export const defaultPacketPoseSettings: PacketPoseSettings = {
  enabled: false,
  positionY: 0,
  rotationXDeg: 0,
  rotationYDeg: 0,
  rotationZDeg: 0,
  scale: 1,
};

export function clonePacketPoseSettings(settings: PacketPoseSettings): PacketPoseSettings {
  return { ...settings };
}

export function assignPacketPoseSettings(target: PacketPoseSettings, source: PacketPoseSettings) {
  Object.assign(target, source);
}
